module.exports = __webpack_public_path__ + "images/assets/05092d745abdf0624dfc675a9a26a801.svg";